import React from "react";

const CardVector = ({ fill }) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.33366 0H10.667C13.8095 0 15.3812 -9.93411e-08 16.357 0.976667C17.0603 1.67917 17.257 2.69083 17.312 4.375H0.688659C0.743659 2.69083 0.940325 1.67917 1.64366 0.976667C2.61949 -9.93411e-08 4.19116 0 7.33366 0ZM10.667 13.3333H7.33366C4.19116 13.3333 2.61949 13.3333 1.64366 12.3567C0.666992 11.3808 0.666992 9.80917 0.666992 6.66667C0.666992 6.29833 0.666992 5.95167 0.668659 5.625H17.332C17.3337 5.95167 17.3337 6.29833 17.3337 6.66667C17.3337 9.80917 17.3337 11.3808 16.357 12.3567C15.3812 13.3333 13.8095 13.3333 10.667 13.3333ZM4.00033 9.375C3.83457 9.375 3.67559 9.44085 3.55838 9.55806C3.44117 9.67527 3.37533 9.83424 3.37533 10C3.37533 10.1658 3.44117 10.3247 3.55838 10.4419C3.67559 10.5592 3.83457 10.625 4.00033 10.625H7.33366C7.49942 10.625 7.65839 10.5592 7.7756 10.4419C7.89281 10.3247 7.95866 10.1658 7.95866 10C7.95866 9.83424 7.89281 9.67527 7.7756 9.55806C7.65839 9.44085 7.49942 9.375 7.33366 9.375H4.00033ZM9.41699 9.375C9.25123 9.375 9.09226 9.44085 8.97505 9.55806C8.85784 9.67527 8.79199 9.83424 8.79199 10C8.79199 10.1658 8.85784 10.3247 8.97505 10.4419C9.09226 10.5592 9.25123 10.625 9.41699 10.625H10.667C10.8328 10.625 10.9917 10.5592 11.1089 10.4419C11.2261 10.3247 11.292 10.1658 11.292 10C11.292 9.83424 11.2261 9.67527 11.1089 9.55806C10.9917 9.44085 10.8328 9.375 10.667 9.375H9.41699Z"
        fill={fill}
      />
    </svg>
  );
};

export default CardVector;
